module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/17NBONK/tc-custom/9781452167794.jpg?1690870251682",
      "alt": "This image is the cover for the book How to Swear"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("How to Swear\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("“Those who grew up with the taste of soap in their mouths are bound to find this book both charming and hilarious.” —"), _c('i', [_vm._v("Imboldn")])]), _c('br'), _c('br'), _vm._v("Even the most profane practitioner of the vulgar tongue must sometimes wonder, “Am I doing it right?” This highly entertaining and crucially informative visual guide to the art of swearing employs a variety of quick-read charts and helpful strategies to take salty skills to the next level. Offering history and etymology along with guidance, quips, insults, answers to lingering questions, and much more, "), _c('i', [_vm._v("How to Swear")]), _vm._v(" celebrates the rude ingenuity of using a naughty word to express surprise, excitement, anger, joy, or disgust, limited only by the imagination. It’s inspiring. It’s educational. It’s dirty. It’s here to change lives or, at the very least, add some f*#&ing color to the conversation."), _c('br'), _c('br'), _c('b', [_vm._v("“A book of lavatorial language made for the smart lavatory . . . entertaining and informative and, if nothing else, remind[s] you of the ")]), _c('a', {
    attrs: {
      "href": "https://www.theguardian.com/lifeandstyle/2016/jan/17/are-you-good-at-swearing-personality-quiz"
    }
  }, [_c('b', [_vm._v("mysterious pleasure of using words that are not meant to be said")])]), _c('b', [_vm._v(".” —"), _c('i', [_vm._v("The Guardian")])]), _c('br'), _c('br'), _c('b', [_vm._v("“A book dedicated to the art of swearing, complete with quick-read charts, diagrams, explications, and strategies to take readers’ salty skills to the next level.” —Medium")])])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stephen Wildish\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Stephen Wildish is a graphic designer specialising in illustration and infographics. He isalso the author of Chartography, and lives in Marlborough.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Chronicle Books LLC\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0